import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISettingsViewAllStatisticsResponse } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS,
  SETTINGS_FULL_STATS_ACCESS_LIST_QUERY_KEY,
  SETTINGS_FULL_STATS_ACCESS_LIST_URL,
} from '../constants';

export default function useSettingsFullStatsAccessListQuery(): IContextQueryResult<ISettingsViewAllStatisticsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsViewAllStatisticsResponse, Error>({
    queryKey: [SETTINGS_FULL_STATS_ACCESS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_FULL_STATS_ACCESS_LIST_URL, {
      signal,

      permission: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS.PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS,
    }),
  });
}
